/*
 * @Author: your name
 * @Date: 2018-08-03 14:02:22
 * @LastEditTime: 2021-08-12 00:15:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cloud-recruit/src/constants/recruit.js
 */
/*
 * @Author: your name
 * @Date: 2018-08-03 14:02:22
 * @LastEditTime: 2021-08-02 09:40:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cloud-recruit/src/constants/recruit.js
 */
/**
 * ==== 招聘管理 ====
 */

// ==== 分类 ====
// 开始请求分类统计信息
export const LOAD_CATEGORY_START = "LOAD_CATEGORY_START";
// 请求分类统计信息结束
export const LOAD_CATEGORY_DONE = "LOAD_CATEGORY_DONE";
// 招聘分类统计信息
export const LOAD_RECRUIT_CATEGORY = "LOAD_RECRUIT_CATEGORY";

// ==== 列表 ====
// 开始请求列表
export const LOAD_LIST_START = "LOAD_LIST_START";
// 结束请求列表
export const LOAD_LIST_DONE = "LOAD_LIST_DONE";
// 招聘人员信息列表
export const LOAD_RECRUIT_LIST = "LOAD_RECRUIT_LIST";

// ==== 推荐职位 ====
export const LOAD_RECOMMEND_START = "LOAD_RECOMMEND_START";
export const LOAD_RECOMMEND_DONE = "LOAD_RECOMMEND_DONE";
export const LOAD_RECOMMEND_LIST = "LOAD_RECOMMEND_LIST";

// ==== Modal ====
// 显示详细信息MODAL
export const SHOW_INFO_MODAL = "SHOW_INFO_MODAL";
// 隐藏详细信息MODAL
export const HIDE_INFO_MODAL = "HIDE_INFO_MODAL";

// 上传简历MODAL
// 显示上传简历MODAL
export const SHOW_UPLOAD_MODAL = "SHOW_UPLOAD_MODAL";
// 隐藏上传简历MODAL
export const HIDE_UPLOAD_MODAL = "HIDE_UPLOAD_MODAL";

// 开始上传简历
export const UPLOAD_RESUME_START = "UPLOAD_RESUME_START";
export const UPLOAD_RESUME_DONE = "UPLOAD_RESUME_DONE";
export const SET_RESETFORM_TRUE = "SET_RESETFORM_TRUE";
export const SET_RESETFORM_FALSE = "SET_RESETFORM_FALSE"

// 显示推荐职位MODAL
export const SHOW_RECOMMEND_MODAL = "SHOW_RECOMMEND_MODAL";
// 隐藏推荐职位MODAL
export const HIDE_RECOMMEND_MODAL = "HIDE_RECOMMEND_MODAL";

// 从职位列表中选择职位
export const SELECT_POSITION = "SELECT_POSITION";

// 点击上传简历，文件名字
export const UP_INFO_NAME = "UP_INFO_NAME";
// 点击上传简历，文件路径
export const UP_INFO_FILEPATH = "UP_INFO_FILEPATH";

export const MATCH_UPRESUME = "MATCH_UPRESUME";




// WEBPACK FOOTER //
// ./src/constants/recruit.js